import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10" aria-label="电影分类导航">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-100">
            电影分类
          </h2>
          <Link
            to="/category/action"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 border border-background-200/50 hover:border-primary-500/30 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-400 group-hover:text-primary-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}